import { render, staticRenderFns } from "./StaticReadOnly.vue?vue&type=template&id=3d72b5ce&"
import script from "./StaticReadOnly.vue?vue&type=script&lang=js&"
export * from "./StaticReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports